export default __webpack_public_path__ + "static/media/limit_60.2e0042f6.svg";